import React, {FC, ReactNode, useCallback, useState} from 'react';

import {isDefined} from '../../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {isTeammateNamespace} from '../../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {TagModel} from '../../../../models/api/tagModel';
import {SettingsTagsUrl} from '../../../../models/url/settingsUrlModel';
import {useFetchHasRulesForTags} from '../../../../settings/fetchers/rulesBundles';
import {ArchiveTagDialogContainer} from '../../../../settings/tags/archiveTagDialogContainer';

/*
 * Types.
 */

/*
 * Props.
 */

interface ArchiveTagWithDialogProps {
  children: (isLoading: boolean, onArchive: () => void) => ReactNode;
  namespace: string;
  onClose?: () => void;
  isInArchivedView?: boolean;
  searchQuery?: string;
  tagsToActOn: ReadonlyArray<TagModel>;
  hasAllSelected?: boolean;
  tagsUrl?: SettingsTagsUrl;
  onArchive: () => void;
}

/*
 * Component.
 */

export const ArchiveTagWithDialog: FC<ArchiveTagWithDialogProps> = (props) => {
  const {tagsToActOn, namespace, children, onArchive, onClose} = props;

  const [isLoading, setIsLoading] = useState(false);
  const [hasSlaRulesForTags, setHasSlaRulesForTags] = useState<boolean>();
  const [hasCsatRulesForTags, setHasCsatRulesForTags] = useState<boolean>();

  const fetchHasRulesForTags = useFetchHasRulesForTags();

  const onArchiveTags = useCallback(async () => {
    if (isLoading) {
      return;
    }

    if (isTeammateNamespace(namespace)) {
      setHasSlaRulesForTags(false);
      setHasCsatRulesForTags(false);
      return;
    }

    setIsLoading(true);

    try {
      const data = await fetchHasRulesForTags(
        tagsToActOn.map((tag) => tag.id),
        namespace,
      );
      setHasSlaRulesForTags(data.hasSlaRulesForTags);
      setHasCsatRulesForTags(data.hasCsatRulesForTags);
    } finally {
      setIsLoading(false);
    }
  }, [namespace, tagsToActOn, fetchHasRulesForTags, isLoading]);

  return (
    <>
      {children(isLoading, onArchiveTags)}
      {isDefined(hasSlaRulesForTags) && isDefined(hasCsatRulesForTags) && (
        <ArchiveTagDialogContainer
          namespace={namespace}
          tagsUrl={props.tagsUrl}
          hasAllSelected={props.hasAllSelected ?? false}
          tagsToActOn={props.tagsToActOn}
          hasSlaRulesForTags={hasSlaRulesForTags}
          hasCsatRulesForTags={hasCsatRulesForTags}
          isInArchivedView={props.isInArchivedView}
          onArchive={onArchive}
          onRequestClose={() => {
            setHasSlaRulesForTags(undefined);
            setHasCsatRulesForTags(undefined);
            onClose?.();
          }}
          searchQuery={props.searchQuery}
        />
      )}
    </>
  );
};
